/* OTF — the offer goal line in the bag. 22 Sep 2026.

   CEO: "agree make it 3 kd and execute" — the pick out of eight reveal
   patterns was the one that RAISES the order instead of discounting it.

   IT ATTACHES FROM THE OUTSIDE. fluid-motion.js is 106 KB and minified, and
   this theme's standing practice for anything that needs to act on the bag is
   a separate script that hooks it from outside rather than an edit to that
   file — see fluid-rv-sheet.js, fluid-sub.js, otf-sheet-locale.js,
   otf-slot-cutoff.js and otf-address-skip.js. This is the same pattern.

   HOW IT KEEPS UP WITH THE CART. fluid-motion.js's render() rewrites only
   .fluid-blines and .fluid-btotals, so an element inserted as a sibling just
   before .fluid-checkout survives every re-render. Two signals tell us to
   re-read: the 'fluidbag' event the bag dispatches on document when it opens,
   and a MutationObserver on .fluid-btotals, which catches a quantity change
   or a delete while the bag is already open.

   THREE STATES, and the third is the one nobody expects:
     under the minimum        -> how far away, with a bar
     the DEAD BAND            -> see below
     everywhere else at/above -> the credit is ready, with a button

   ⚠ THE DEAD BAND, MEASURED 22 Sep. Free delivery here is a delivery RATE,
   not a discount — 3.000 KD under 45, free at 45 and over — and Shopify
   evaluates that rate on the total AFTER discounts. Proven on a real cart:
   47.000 got free delivery; applying HALA took it to 44.000 and the rate came
   back at 3.000. So between 45.000 and 47.999 a 3 KD code saves the shopper
   EXACTLY NOTHING — three off the flowers, three back on the van. In that
   band this line does not offer the code. It asks for a little more so they
   keep both. Move the credit or the free-delivery line and the band moves;
   both are settings on the section.

   ⚠ MONEY UNITS — THE AJAX CART USES HUNDREDTHS, NOT FILS. This is the one
   thing to get right here, and it was got WRONG on the first build. KWD has
   three decimals, so the obvious assumption is that /cart.js reports 35.000 KD
   as 35000. IT DOES NOT. It reports 3500 — the Ajax API scales every price by
   100 whatever the currency's real precision. MEASURED 22 Sep: Mi Amor is
   35.000 KD in admin and comes back as 3500; Coco Bloom is 60.000 and comes
   back as 6000. So DIVIDE BY 100, and the thresholds handed over by the
   section are KD * 100. Display keeps three decimals because that is how
   Kuwait writes money. If this line ever claims a shopper is hundreds of
   dinars from the minimum, this is the bug you are looking at.

   IT READS items_subtotal_price, NOT total_price, because the discount
   minimum is measured against the subtotal before any cart-level discount.

   IT IS INERT unless sections/otf-offer-goal.liquid rendered its data
   element, which it does not do for a customer who has already ordered.
   */
(function () {
  var src = document.getElementById('otf-goal-data');
  if (!src) return;

  var A = function (k) { return src.getAttribute(k); };
  var TH = parseInt(A('data-threshold'), 10);
  var FREE = parseInt(A('data-free'), 10);
  var AMT = parseInt(A('data-amount'), 10);
  var HREF = A('data-href');
  var T = {
    away: A('data-t-away'), awaySub: A('data-t-away-sub'),
    open: A('data-t-open'), openSub: A('data-t-open-sub'),
    both: A('data-t-both'), bothSub: A('data-t-both-sub'),
    cta: A('data-t-cta')
  };
  if (!TH || TH < 1 || !FREE || !AMT || !HREF) return;

  /* hundredths -> KD, written the Kuwaiti way with three decimals */
  function money(minor) { return (minor / 100).toFixed(3); }

  var el = null, busy = false, timer = 0, watching = false;

  /* the block lives just above Checkout, like the member card, because the
     sheet is anchored to the bottom and grows UPWARD — anything added above
     Checkout leaves Checkout where the thumb already is. */
  function slot() {
    var bag = document.querySelector('.fluid-bag');
    if (!bag) return null;
    var co = bag.querySelector('.fluid-checkout');
    if (!co) return null;
    if (!el || !el.isConnected) {
      el = document.createElement('div');
      el.className = 'otf-goal';
      el.hidden = true;
      co.parentNode.insertBefore(el, co);
    }
    return el;
  }

  function line(cls, text) {
    var d = document.createElement('div');
    d.className = cls;
    d.textContent = text;
    return d;
  }

  function bar(frac) {
    var b = document.createElement('div');
    b.className = 'og-bar';
    var fill = document.createElement('i');
    fill.style.transform = 'scaleX(0)';
    b.appendChild(fill);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.transform = 'scaleX(' + Math.max(0, Math.min(1, frac)).toFixed(4) + ')';
      });
    });
    return b;
  }

  function paint(cart) {
    var e = slot();
    if (!e) return;
    e.textContent = '';

    /* nothing to say: empty bag, or a code is already on it — never offer a
       swap, because Shopify allows one code per cart and the shopper would
       silently lose the one they have. */
    if (!cart || !cart.item_count) { e.hidden = true; return; }
    if (cart.discount_codes && cart.discount_codes.length) { e.hidden = true; return; }

    var sub = cart.items_subtotal_price;
    if (typeof sub !== 'number') { e.hidden = true; return; }

    if (sub < TH) {
      e.className = 'otf-goal';
      e.appendChild(line('og-h', T.away.replace('{amount}', money(TH - sub))));
      e.appendChild(bar(sub / TH));
      if (T.awaySub) e.appendChild(line('og-s', T.awaySub));
    } else if (sub >= FREE && sub < FREE + AMT) {
      /* the dead band — taking the code here would cost the free delivery */
      e.className = 'otf-goal is-both';
      e.appendChild(line('og-h', T.both.replace('{amount}', money(FREE + AMT - sub))));
      e.appendChild(bar((sub - FREE) / AMT));
      if (T.bothSub) e.appendChild(line('og-s', T.bothSub));
    } else {
      e.className = 'otf-goal is-open';
      e.appendChild(line('og-h', T.open));
      if (T.openSub) e.appendChild(line('og-s', T.openSub));
      var a = document.createElement('a');
      a.className = 'og-cta fluid-press';
      a.href = HREF;
      a.textContent = T.cta;
      e.appendChild(a);
    }
    e.hidden = false;
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c); })
      .catch(function () { })
      .then(function () { busy = false; });
  }

  function soon() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 140);
  }

  function watch() {
    if (watching) return;
    var tot = document.querySelector('.fluid-bag .fluid-btotals');
    if (!tot || !window.MutationObserver) return;
    watching = true;
    new MutationObserver(soon).observe(tot, { childList: true });
  }

  document.addEventListener('fluidbag', function (e) {
    if (e && e.detail && e.detail.open) { watch(); soon(); }
  });

  /* the cart page and a deep link can both arrive with the bag already
     populated and never fire 'fluidbag', so read once on load too. */
  watch();
  soon();
})();
